<mprd-internet-settings-skeleton *ngIf="!internetProductDetails"></mprd-internet-settings-skeleton>
<div *ngIf="internetProductDetails">
  <h2 class="rs-tit3">{{ 'internet.settings.title' | translate }}</h2>
  <px-alert
    *ngIf="!internetProductDetails.internetLoginId"
    [alerts]="[
      {
        type: 'error',
        description: 'internet.settings.safety.update.failed' | translate,
        isClosable: false,
        taggingErrorType: 'backend'
      }
    ]"
  ></px-alert>
  <span *ngIf="internetProductDetails.internetLoginId">
    <ng-container *ngIf="showHgw4">
      <mprd-accordion-panel
        [dataCyTitle]="'homeGatewayTitle'"
        [dataCySelector]="'accordionHomeGateway'"
        [title]="'internet.settings.home.gateway.title' | translate"
        [expanded]="true"
      >
        <mprd-home-gateway
          [accessNumber]="internetProductDetails.accessNumber"
          data-cy="homeGatewaySection"
        ></mprd-home-gateway>
      </mprd-accordion-panel>
    </ng-container>

    <mprd-accordion-panel
      [dataCyTitle]="'internetUpdatePasswordTitle'"
      [dataCySelector]="'accordionChangePassword'"
      [title]="'internet.settings.password.title' | translate"
    >
      <mprd-update-internet-password
        [loginId]="internetProductDetails.internetLoginId"
      ></mprd-update-internet-password>
    </mprd-accordion-panel>

    <ng-container *ngIf="technicalProfile">
      <mprd-accordion-panel
        [dataCyTitle]="'internetModemSafetyTitle'"
        [dataCySelector]="'accordionModemSafety'"
        [title]="'internet.settings.safety.title' | translate"
      >
        <mprd-modem-safety
          [loginId]="internetProductDetails.internetLoginId"
          [technicalProfile]="technicalProfile"
        >
        </mprd-modem-safety>
      </mprd-accordion-panel>
    </ng-container>

    <ng-container *ngIf="cgnFlag">
      <mprd-accordion-panel
        [title]="'internet.settings.shared.ip.title' | translate"
        [dataCySelector]="'accordionShareIp'"
      >
        <mprd-shared-ip [loginId]="internetProductDetails.internetLoginId"></mprd-shared-ip>
      </mprd-accordion-panel>
    </ng-container>

    <ng-container *ngIf="fixedIpActive && isFixedIpEnabled">
      <mprd-accordion-panel
        [dataCyTitle]="'internetFixedIpTitle'"
        [title]="'internet.settings.fix.ip.mac.address.title' | translate"
        [dataCySelector]="'accordionFixedIp'"
        data-tms-event="link-click"
        attr.data-tms-link-zone="{{ 'internet.settings.fix.ip.mac.address.title' | translate }}"
        data-tms-link-name="{{ 'internet.settings.fix.ip.mac.address.title' | translate }}"
      >
        <mprd-fixed-ip [circuitId]="internetProductDetails.accessNumber"></mprd-fixed-ip>
      </mprd-accordion-panel>
    </ng-container>

    <ng-container
      *ngIf="!cgnFlag && ('modem-choice.enable' | translate) !== 'false'"
    >
      <mprd-accordion-panel
        [title]="'internet.settings.modem-choice.title' | translate"
      >
        <mprd-modem-choice-entrypoint
          class="columns small-12 medium-8"
          [circuitId]="internetProductDetails.accessNumber"
        ></mprd-modem-choice-entrypoint>
      </mprd-accordion-panel>
    </ng-container>
  </span>
</div>
